import { clientNetworkTag, isTelemetryActive } from './client';
import { beaconVitals } from './vitals-beacon';

interface NatsReadyInfo {
  readonly credentialKind: 'anon' | 'user';
  readonly durationMs: number;
  /** Where the time went; absent on SDK versions that do not report phases. */
  readonly phases?: {
    readonly mintMs: number;
    readonly connectMs: number;
    readonly bootstrapMs: number;
  };
}

export function reportNatsStartup(info: NatsReadyInfo): void {
  if (!isTelemetryActive()) return;
  beaconVitals({
    kind: 'nats-startup',
    value: info.durationMs,
    credentialKind: info.credentialKind,
    network: clientNetworkTag(),
    ...(info.phases !== undefined
      ? {
          mintMs: info.phases.mintMs,
          connectMs: info.phases.connectMs,
          bootstrapMs: info.phases.bootstrapMs,
        }
      : {}),
  });
}
